import { Epic, StateObservable, ofType } from 'redux-observable';
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { Observable, catchError, concatMap, from, mergeMap, of } from 'rxjs';
import { ToastNotification } from '@scenario/models/toast-notification.model';
import {
  unsubscribeToNotificationFailure,
  unsubscribeToNotificationSuccess,
} from '@store/scenario/subscription/subscription-slice';
import { displayToast } from '@store/toast-notifications/toast-notifications-slice';

export const unsubscribeToNotificationEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
)=>   action$.pipe(
  ofType('subscription/unsubscribeToNotification'),
  concatMap((action: PayloadAction<number>) =>
    from(dependencies.subscriptionGateway.unsubscribeToNotification(action.payload)).pipe(
      mergeMap(() => {
        const toastNotification: ToastNotification = {
          title: 'Unsubscription to notification',
          content: 'Successfully unsubscribed to notification',
          status: 'info',
          closeIconButtonLabel: 'close',
          reference: dependencies.idProvider.generate(),
        };
        return of(unsubscribeToNotificationSuccess(action.payload), displayToast(toastNotification));
      }),
      catchError(() =>
        of(
          unsubscribeToNotificationFailure('Unable to unsubscribe to notification'),
          displayToast({
            title: 'Unsubscription to notification',
            content: 'We are unable to create a subscription for this notification',
            status: 'danger',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          }),
        ),
      ),
    ),
  ),
);
